import memoize from 'lru-memoize';
import { createValidator, required } from '../../utils/validation';

const apiKeysValidation = createValidator({
  application: required,
  permissions: required,
});
export default memoize(10)(apiKeysValidation);
